module.exports = __webpack_public_path__ + "static/media/healthtech.9097f991.png";